import React, {useEffect, useState} from "react";
import {
    addNoteToWellnessSurvey,
    downloadWellnessSurveyPdf,
    getPatientWellnessSurveys,
    sendWellnessSurvey
} from "../../../core/axios/services";
import {useSelector} from "react-redux";
import Headline from "../Comon/Headline/Headline";
import Button from "../Comon/Button/Button";
import {useTranslation} from "react-i18next";
import TextInput from "../Comon/TextInput/TextInput";
import {Box} from "@mui/material";
import GetWellnessSurveyLinkForLanguageModal from "../GetWellnessSurveyLinkForLanguageModal";
import {useNavigate} from "react-router-dom";

export function PatientWellnessTable({
                                         patient,
                                         showGlobalSnackbar = () => {},
                                         setLink = () => {},
                                         data,
                                         setData = () => {},
                                     })
{
    const { i18n } = useTranslation();

    const user = useSelector((state) => state.user);
    const [surveys, setSurveys] = useState();

    async function handleGetPatientWellnessSurveys() {
        if(!patient?.id){
            return;
        }

        let result = await getPatientWellnessSurveys(patient?.id,user);

        if(result?.status === 200){
            setSurveys(result?.data?.data)
        }
    }

    useEffect(() => {
        if(patient){
            handleGetPatientWellnessSurveys();
        }
    }, [patient]);


    const [showNoteModal, setShowNoteModal] = useState(false);
    const [note, setNote] = useState();
    async function handleAddNoteToWellnessSurvey(){
        const result = await addNoteToWellnessSurvey({
            id: showNoteModal?.id,
            note: note,
        }, user);

        if (result?.status === 200) {
            // Prefer common shapes: axios returns updated item in result.data.data
            const updatedSurvey = result?.data?.data ?? result?.data ?? null;

            if (updatedSurvey?.id) {
                setSurveys((prev) => {
                    const prevList = Array.isArray(prev) ? prev : [];
                    return prevList.map((s) => (s?.id === updatedSurvey.id ? updatedSurvey : s));
                });
            }
        }

        setShowNoteModal(false);
    }

    function handleShowNoteModal(item){
        setShowNoteModal(item);
        setNote(item?.note ?? '');
    }


    function getNextSurveyLink(){
        return `${process.env.REACT_APP_API_WEBVIEW}/wellness/${patient?.wellnessSurveyCode}?patientId=${patient?.uuid}&order=${surveys?.length + 1}`;
    }

    function handleSendWellnessSurvey(){
        sendWellnessSurvey(
            getNextSurveyLink()
             , patient?.id, user);
        showGlobalSnackbar(i18n.t("linkSent"));
    }


    function handleCopyNextSurveyLink(){
        navigator.clipboard.writeText(getNextSurveyLink());
        showGlobalSnackbar(i18n.t("linkCopied"));
    }

    const navigate = useNavigate();

    function handleEditWellnessSurvey(item) {
        // Construct the path
        const path = `/wellness-edit/${item?.wellnessSetting?.code}?surveyId=${item?.id}`;

        // Use window.open for a new tab
        window.open(path, '_blank', 'noopener,noreferrer');
    }



    async function handleDownloadWellnessSurveyPdf(item){
        try {
            // // Backend returns { url, path }
            // const result = await downloadWellnessSurveyPdf({
            //     id: item?.id,
            //     patient_id: patient?.id,
            // }, user);
            //
            // const payload = result?.data?.data ?? result?.data ?? null;
            // const url = payload?.url;
            //
            // if (url) {
            //     // Open in a new tab to trigger browser download/view
            //     window.open(url, "_blank", "noopener,noreferrer");
            //     return;
            // }
            showGlobalSnackbar(i18n.t("loading"), 5000);
            downloadWellnessSurveyPdf({
                id: item?.id,
                patient_id: patient?.id,
            }, user).then((res) => {
                let filename = res.headers.get("filename");
                filename = decodeURIComponent(escape(filename));
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
            });
        } catch (e) {
            console.error(e);
            showGlobalSnackbar(i18n.t("somethingWentWrong"));
        }
    }



    return <>
        {
            (patient?.isInWellnessFlow ||  surveys?.length >= 1) && <div>
                <Headline text={'Wellness Surveys'} type={"Headline-medium"} />

                {
                    showNoteModal && <div className="ScreenOverlay">
                        <div className="ScreenContent">
                            <h1 style={{textAlign:'center'}}>{i18n.t('surveyNotesTitle')}</h1>

                            <Box className={"textContainer"}>
                                <TextInput
                                    rows={7}
                                    mode={"white"}
                                    placeholder={i18n.t("surveyNotesTitle")}
                                    type={"textarea"}
                                    setValue={(val) => setNote(val)}
                                    value={note}
                                />
                            </Box>

                            <div
                                className={"ConfirmPopUpButtonContainer"}
                                onClick={() => handleAddNoteToWellnessSurvey()}
                            >
                                <Button text={'Save'} mode={"small"} />
                            </div>
                            <div className={"denyPopupButton"} onClick={() => setShowNoteModal(false)}>
                                {'No, go back'}
                            </div>

                        </div>
                    </div>
                }


                <div style={{marginTop:'50px'}}>

                    <div
                        style={{
                            height: '50px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            paddingRight: '20px',
                            paddingLeft: '50px',
                        }}
                    >
                        <div style={{width:'calc(100%/3)',color:'#9c9c9c'}} >Survey</div>
                        <div style={{width:'calc(100%/3)',color:'#9c9c9c'}} >Date</div>
                        <div style={{width:'calc(100%/3)',color:'#9c9c9c'}} ></div>
                    </div>
                    {
                        surveys?.map((item,index) => {

                            return <div
                                key={index}
                                style={{
                                    width:'100%',
                                }}
                            >
                                <div
                                    style={{
                                        height: '50px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        background: (index % 2 === 0) ? '#f4f4f3' : 'white',
                                        paddingRight: '20px',
                                        paddingLeft: '50px',
                                    }}
                                >

                                    <div
                                        style={{
                                            width:'calc(100%/3)',
                                        }}
                                    >
                                        Wellness Survey {item?.order}
                                    </div>

                                    <div
                                        style={{
                                            width:'calc(100%/3)',
                                        }}
                                    >
                                        {item?.createdAt}
                                    </div>

                                    <div
                                        style={{
                                            width:'calc(100%/3)',
                                        }}
                                    >
                                        <div className={"smallButtonsCell"}>
                                            <div
                                                className={"smallButtonContainers"}
                                                onClick={() => handleShowNoteModal(item)}
                                            >
                                                <Button
                                                    text={i18n.t("addNotes")}
                                                    mode={"small"}
                                                    color={"white"}
                                                />
                                            </div>

                                            <div
                                                className={"smallButtonContainers"}
                                                onClick={() => handleDownloadWellnessSurveyPdf(item)}
                                                style={{minWidth:'110px'}}
                                            >
                                                <Button
                                                    text={i18n.t("generatePdf")}
                                                    mode={"small"}
                                                />
                                            </div>

                                            <div className={"smallButtonsCell"}>
                                                <div
                                                    className="viewResultsCell"
                                                    onClick={() => handleEditWellnessSurvey(item)}
                                                >
                                                    {i18n.t("viewResults")}{" "}
                                                    <img
                                                        className={"rightArrowIcon"}
                                                        alt="rightArrowIcon"
                                                        src={"/assets/Icon_Arrow-Right.svg"}
                                                        width="9px"
                                                        height="100%"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        })
                    }

                    {
                        patient?.isInWellnessFlow && <div
                            style={{
                                height: '50px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                background: ((surveys?.length) % 2 === 0) ? '#f4f4f3' : 'white',
                                paddingRight: '20px',
                                paddingLeft: '50px',
                            }}
                        >
                            <div
                                style={{
                                    width:'calc(100%/3)',
                                }}
                            >
                                Wellness Survey {surveys?.length + 1}
                            </div>

                            <div>
                                {
                                    (surveys?.length > 0) && <div className={"smallButtonsCell"}>
                                        <div
                                            className={"smallButtonContainers"}
                                            onClick={() => handleSendWellnessSurvey()}
                                        >
                                            <Button
                                                text={i18n.t("sendToEmail")}
                                                mode={"small"}
                                                color={"white"}
                                            />
                                        </div>

                                        <div
                                            className={"smallButtonContainers"}
                                            onClick={() => handleCopyNextSurveyLink()}
                                        >
                                            <Button
                                                text={i18n.t("copyLink")}
                                                mode={"small"}
                                            />
                                        </div>
                                    </div>
                                }


                                {
                                    (surveys?.length === 0) && <div className={"smallButtonsCell"}>
                                        <div
                                            className={"smallButtonContainers"}
                                            onClick={() => console.log('generateSurvey')}
                                        >
                                            {/*<Button*/}
                                            {/*    text={i18n.t("generateSurvey")}*/}
                                            {/*    mode={"small"}*/}
                                            {/*/>*/}
                                            <GetWellnessSurveyLinkForLanguageModal
                                                patient={patient}
                                                showGlobalSnackbar={showGlobalSnackbar}
                                                setLink={setLink}
                                                data={data}
                                                setData={setData}
                                            />

                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>

            </div>
        }

    </>
}
